import { render, staticRenderFns } from "./CommitIcon.vue?vue&type=template&id=5f184212&"
import script from "./CommitIcon.vue?vue&type=script&lang=ts&"
export * from "./CommitIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports